import { useContext, useCallback } from "react";
import { useProtectedAPI, usePublicAPI } from "./apiService";
import { AuthContext } from "@/components/AuthContext";
import { objectToQueryString } from "@/utils/objectToQueryString";

import useSWR from "swr";


export const useAuth = () => {
  return useContext(AuthContext);
}


export const useLogin = () => {

    const publicAPI = usePublicAPI()
    // const protectedAPI = useProtectedAPI()

    const login = async (username, password) => {

        let response = await publicAPI.post("/oauth2/login", 
            {
                username: username,
                password: password,
            },
            {
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded",
                },
                withCredentials: true,
            }
        );

        return response.data;

        /*if (response.data.access_token) {
            const at = response.data.access_token;
            
            response = await protectedAPI.get("/me/profile", {
                headers: {
                    Authorization: `Bearer ${at}`,
                },
            });

            if (response?.data?.first_name) {
                return { at: at, user: response.data };
            } else {
                console.log(response)
                throw new Error("Impossible de récupérer le profil de l'utilisateur");
            }
        }
        else {
            throw new Error("Tokens non fournis");
        }*/
    }

    return login
}



export const useLogout = () => {

    const publicAPI = usePublicAPI()

    const logout = async () => {

    const response = await publicAPI.get("/oauth2/logout", { withCredentials: true });

    return response.data;

    }

    return logout
}



export const useGetProfile = () => {

    const protectedAPI = useProtectedAPI()

    const getProfile =  useCallback(async (customAccessToken) => {

        let response;

        if (customAccessToken) {
            response = await protectedAPI.get("/me/profile", {
                headers: {
                    Authorization: `Bearer ${customAccessToken}`,
                },
            });
        } else {
            response = await protectedAPI.get("/me/profile");
        }
        
        return response.data;
    }, [protectedAPI])

    return getProfile;
}



export const useGetPingSWR = (shouldFetch) => {

    const protectedAPI = useProtectedAPI()
    const fetcher = (url) => protectedAPI.get(url).then((res) => res.data);

    const { data, error, isLoading, isValidating, mutate } = useSWR( (shouldFetch) ? `/me/ping` : null, fetcher, {refreshInterval: 60 * 1000, revalidateOnFocus: false, refreshWhenHidden: false});

    return {
        data,
        error,
        isLoading,
        isValidating,
        callToAction: mutate,
    };
}



export const useUpdateProfile = () => {
    const protectedAPI = useProtectedAPI();

    const updateProfile = async (updateObject) => {
        const response = await protectedAPI.put("/me/profile", updateObject);
        return response;
    }

    return updateProfile;
}



export const useProfileUploadPicture = () => {
    const protectedAPI = useProtectedAPI();

    const profileUploadPicture = useCallback(async (file) => {
        const formData = new FormData();
        formData.append("file", file);

        const response = await protectedAPI.post("/me/picture", formData, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
            withCredentials: true,
        });
        return response.data;
    }, [protectedAPI])

    return profileUploadPicture;
}



export const useProfileDeletePicture = () => {
    const protectedAPI = useProtectedAPI();

    const profileDeletePicture = useCallback(async () => {
        const response = await protectedAPI.delete("/me/picture", {
            withCredentials: true,
        });
        return response.data;
    }, [protectedAPI])

    return profileDeletePicture;
}



/* Admin Endpoints */

export const useAdminGetUsers = () => {
    const protectedAPI = useProtectedAPI()

    const adminGetUsers = (filters) => {

        const queryString = objectToQueryString(filters)
        const url = `/admin/users?${queryString}`

        const promise = protectedAPI.get(url).then(response => {
            return {
                data: response.data,
                total: response.headers["x-total-count"]
            }
        })

        return {
            then: (resolve, reject) =>
                promise.then(result => resolve(result.data), reject),
            catch: (reject) =>
                promise.catch(reject),
            withTotal: () =>
                promise.then(result => [result.data, result.total])
        }
    }

    return adminGetUsers
}



export const useAdminGetUser = () => {
    const protectedAPI = useProtectedAPI()

    const adminGetUsers = async (id) => {

    const url = `/admin/user/${id}`

    const response = await protectedAPI.get(url)
    return response.data
    }

    return adminGetUsers
}



export const useAdminUpdateUser = () => {
    const protectedAPI = useProtectedAPI();

    const adminUpdateUser = async (id, updateObject) => {

    const response = await protectedAPI.put('/admin/user/' + id, updateObject)
    return response;
    }

    return adminUpdateUser

}



export const useAdminCreateUser = () => {
    const protectedAPI = useProtectedAPI();

    const adminCreateUser = async (updateObject) => {

        const response = await protectedAPI.post('/admin/user', updateObject)
        return response;
    }

    return adminCreateUser

}


  
export const useAdminDeleteUser = () => {
    const protectedAPI = useProtectedAPI();

    const adminDeleteUser = async (id) => {

        const response = await protectedAPI.delete(`/admin/user/${id}`)
        return response;
    }

    return adminDeleteUser

}



export const useAdminReivite = () => {
    const protectedAPI = useProtectedAPI();

    const adminReivite = async (id, resetPassword) => {
        const response = await protectedAPI.post(`/admin/user/${id}/invite?reset_password=${resetPassword}`)
        return response;
    }

    return adminReivite
}



export const useAdminUploadPicture = () => {
    const protectedAPI = useProtectedAPI();

    const adminUploadPicture = useCallback(async (id, file) => {
        const formData = new FormData();
        formData.append("file", file);

        const response = await protectedAPI.post(`/admin/user/${id}/picture`, formData, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
            withCredentials: true,
        });
        return response.data;
    }, [protectedAPI])

    return adminUploadPicture;
}



export const useAdminDeletePicture = () => {
    const protectedAPI = useProtectedAPI();

    const adminDeletePicture = useCallback(async (id) => {
        const response = await protectedAPI.delete(`/admin/user/${id}/picture`, {
            withCredentials: true,
        });
        return response.data;
    }, [protectedAPI])

    return adminDeletePicture;
}